// extracted by mini-css-extract-plugin
module.exports = {"ModalWrapper":"SwapModal_ModalWrapper__1pJ2Y","SwapWrapper":"SwapModal_SwapWrapper__6924I","DropDownsWrapper":"SwapModal_DropDownsWrapper__2gdY4"};